import { v } from "convex/values";
import {
  internalControl,
  defineTableWithInternalControl,
} from "../../../lib/shared/validators";

export const workOrderServiceStatus = v.union(
  v.literal("pending"),
  v.literal("in_progress"),
  v.literal("completed"),
);

export const validatorWorkOrderService = v.object({
  workOrderId: v.id("work_orders"),
  serviceId: v.optional(v.id("services")),

  // Snapshot de informacion.
  name: v.string(),
  description: v.optional(v.string()),
  code: v.optional(v.string()),
  sku: v.optional(v.string()),

  // Datos especificos por orden.
  quantity: v.optional(v.number()),
  unitPrice: v.number(),
  unit: v.optional(v.string()),
  costPrice: v.optional(v.number()),

  // Impuestos y descuentos.
  taxRate: v.optional(v.number()),
  taxAmount: v.optional(v.number()),
  isExempt: v.optional(v.boolean()),
  exemptRate: v.optional(v.number()),
  exemptAmount: v.optional(v.number()),
  discountRate: v.optional(v.number()),
  discountAmount: v.optional(v.number()),

  // Calculados.
  subtotal: v.optional(v.number()),
  totalAmount: v.optional(v.number()),

  // Estado y notas.
  status: v.optional(workOrderServiceStatus),
  notes: v.optional(v.string()),

  internalControl,
});

export const work_order_services = defineTableWithInternalControl(
  validatorWorkOrderService,
)
  .index("by_work_order", ["workOrderId"])
  .index("by_service", ["serviceId"])
  .index("by_work_order_and_service", ["workOrderId", "serviceId"])
  .index("by_company_and_work_order", [
    "internalControl.companyId",
    "workOrderId",
  ])
  .index("by_branch_and_work_order", [
    "internalControl.branchId",
    "workOrderId",
  ])
  .index("by_status", ["status"]);